import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getRolePermissions = async (token, params) => {
  const url = `roles/${params.role_id}/permissions`

  const data = await apiGet({ url, token, params })
  return data
}

export function useRolePermissions({ params, options = {} }) {
  const token = useContext(AuthContext)

  return useQuery(
    [`roles/${params.role_id}/permissions`, params],
    () => getRolePermissions(token, params),
    {
      ...options
    }
  )
}
